import { SearchUtilsService } from './search.service';

export default angular
  .module('sfMobile.services.searchUtils', [])
  .service('searchUtilsService', SearchUtilsService).name;
